import api from "./index";
import ENDPOINTS from "./endpoints";

export async function stopGeneration(chatId, answerId) {
  const response = await api({
    method: "POST",
    url: ENDPOINTS.STOP_GENERATION,
    data: { chat_id: chatId, answer_id: answerId },
  });
  return response.data;
}